export default "__VITE_ASSET__CZYZt3Op__"